import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  googleMapOption: {
    width: '100%',
    borderTop: 'solid 1px black',
    padding: theme.spacing(1, 0)
  }
}));
